import { render, staticRenderFns } from "./page.vue?vue&type=template&id=ca83c9e2&scoped=true"
import script from "./page.vue?vue&type=script&lang=ts"
export * from "./page.vue?vue&type=script&lang=ts"
import style0 from "./page.vue?vue&type=style&index=0&id=ca83c9e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca83c9e2",
  null
  
)

export default component.exports